import clsx from 'clsx';
import { TONE_CLASSES } from '../../dpRequests.definitions';
import type { StatusPillProps } from './statusPill.types';

export function StatusPill({ label, tone, className }: StatusPillProps) {
    return (
        <span
            className={clsx(
                'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset whitespace-nowrap',
                TONE_CLASSES[tone],
                className
            )}
        >
            {label}
        </span>
    );
}
